<template>
  <div>
    <div
      v-if="loading"
      class="d-flex"
    >
      <v-col cols="12">
        <v-sheet
          v-if="loading"
          :color="'grey lighten-4'"
          class="pa-3"
        >
          <v-skeleton-loader type="card-heading, table-row-divider">
          </v-skeleton-loader>
        </v-sheet>
      </v-col>
    </div>

    <div
      v-if="!loading"
      class="d-flex header-card"
    >
      <div class="col-2">
        <v-card
          elevation="3"
          class="fill-height"
          color="var(--app-light-secondary-color)"
        >
          <div class="info-item-details text-center overflow-hidden">
            <div class="info-item-details-header">
              {{ local.caseFile.tableHeader.caseCode }}
            </div>
            <div
              class="info-item-details-value text-h5 mt-3"
              :title="caseDetails.caseCode"
            >
              {{ caseDetails.caseCode }}
            </div>
          </div>
        </v-card>
      </div>
      <div class="col-10">
        <v-card elevation="3">
          <div class="info-item-box pa-0 ma-0">
            <div
              v-for="(header, index) in tableHeader"
              :key="header.value"
              class="info-item-details"
              :class="index==0 ? ' info-item-box-b': ''"
            >
              <div class="info-item-details-header">
                {{ header.text }}
              </div>
              <div class="font-info mt-3">
                {{ header.formatter ? header.formatter(caseDetails[header.value]) :caseDetails[header.value] }}
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </div>
    <div class="d-flex header-card">
      <div class="col-2">
        <v-card
          elevation="2"
          outlined
          class="fill-height"
        >
          <v-tabs
            v-model="tab"
            vertical
            hide-slider
          >
            <template v-for="tabButton in caseFileTabs">
              <v-tab
                :key="tabButton.href"
                :disabled="tabButton.isDisabled"
                :href="tabButton.href"
                class="tab-button"
                active-class="tab-active"
              >
                <v-icon
                  left
                  class="tab-button-icon"
                >
                  {{ tabButton.icon }}
                </v-icon>
                <span class="mr-1"> {{ tabButton.title }}</span>
              </v-tab>
            </template>
          </v-tabs>
        </v-card>
      </div>
      <div class="col-10">
        <naj-alert v-if="caseDetails.isBankruptcy" type="information">
          <template slot="content">
            {{ local.home.tabCommon.bankruptcyCaseAlert }}
          </template>
        </naj-alert>
        <v-tabs-items v-model="tab">
          <v-card elevation="2">
            <v-tab-item value="tab-1">
              <v-sheet
                v-if="loading"
                :color="'grey lighten-4'"
                class="pa-3"
              >
                <v-skeleton-loader type="heading, list-item-two-line ,heading , list-item-two-line,heading , list-item-two-line">
                </v-skeleton-loader>
              </v-sheet>

              <case-details-tab
                v-if="!loading"
                :case-details="caseDetails"
                :loading="loading"
              ></case-details-tab>
            </v-tab-item>
            <v-tab-item value="tab-2">
              <lawsuit-case-replies-tab
                :case-object-key="caseObjectKey"
                :is-pega="isPega"
              ></lawsuit-case-replies-tab>
            </v-tab-item>
            <v-tab-item value="tab-3">
              <case-parties-tab
                :case-object-key="caseObjectKey"
                :is-pega="isPega"
              ></case-parties-tab>
            </v-tab-item>
            <v-tab-item value="tab-4">
              <case-sessions-tab
                :case-object-key="caseObjectKey"
                :is-pega="isPega"
                :court-id="caseDetails.courtId"
              ></case-sessions-tab>
            </v-tab-item>

            <v-tab-item value="tab-5">
              <case-judgments-tab
                :case-object-key="caseObjectKey"
                :is-pega="isPega"
                :is-secret-judgements="caseDetails.isSecretJudgements"
              ></case-judgments-tab>
            </v-tab-item>

            <v-tab-item value="tab-6">
              <v-card
                flat
                class="tab-details"
              >
                <case-requests-tab
                  :case-object-key="caseObjectKey"
                  :is-pega="isPega"
                  :is-bankruptcy-migrated="caseDetails.isBankruptcy"
                ></case-requests-tab>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-7">
              <v-card
                flat
                class="tab-details"
              >
                <case-decisions-tab
                  :case-object-key="caseObjectKey"
                  :is-pega="isPega"
                ></case-decisions-tab>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-8">
              <case-fees-tab
                :case-object-key="caseObjectKey"
                :is-pega="isPega"
              ></case-fees-tab>
            </v-tab-item>

            <v-tab-item value="tab-9">
              <v-card
                flat
                class="tab-details"
              >
                <case-documents-tab
                  :case-object-key="caseObjectKey"
                  :is-pega="isPega"
                ></case-documents-tab>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-10">
              <v-card
                flat
                class="tab-details"
              >
                <case-procedures-tab
                  :case-object-key="caseObjectKey"
                  :is-pega="isPega"
                ></case-procedures-tab>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-11">
              <v-card
                flat
                class="tab-details"
              >
                <case-suspensions-tab
                  :case-object-key="caseObjectKey"
                  :is-pega="isPega"
                ></case-suspensions-tab>
              </v-card>
            </v-tab-item>
          </v-card>
        </v-tabs-items>
      </div>
    </div>

    <update-attorney-details
      :form-model="formModel"
      :modal-visibility="showUpdateAttorneyDetailsModal"
      @casePartyAttorneyUpdate="casePartyAttorneyUpdate"
    ></update-attorney-details>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import CasePartiesTab from './tabs/case-parties-tab.vue';
import CaseSessionsTab from './tabs/case-sessions-tab.vue';
import CaseJudgmentsTab from './tabs/case-judgments-tab.vue';
import CaseDocumentsTab from './tabs/case-documents-tab.vue';
import CaseRequestsTab from './tabs/case-requests-tab.vue';
import CaseProceduresTab from './tabs/case-procedures-tab.vue';
import CaseDecisionsTab from './tabs/case-decisions-tab.vue';
import CaseDetailsTab from './tabs/case-details-tab.vue';
import CaseFeesTab from './tabs/case-fees-tab.vue';
import UpdateAttorneyDetails from '../../../../modules/global/components/update-attorney-details';
import LawsuitCaseRepliesTab from './tabs/lawsuit-case-replies-tab.vue';
import CaseSuspensionsTab from './tabs/case-suspensions-tab.vue';

import { getDayMonthHijri } from '@/helpers/utils';
const { mapActions } = createNamespacedHelpers('CasesModule');

export default {
  components: {
    CaseSessionsTab,
    CasePartiesTab,
    CaseJudgmentsTab,
    CaseDetailsTab,
    CaseRequestsTab,
    CaseDecisionsTab,
    CaseFeesTab,
    UpdateAttorneyDetails,
    LawsuitCaseRepliesTab,
    CaseDocumentsTab,
    CaseProceduresTab,
    CaseSuspensionsTab,
  },
  data() {
    return {
      caseDetails: {},
      tab: null,
      tableHeader: [
        {
          value: 'caseCategoryName',
          text: this.local.caseFile.tableHeader.caseCategoryName,
        },
        {
          value: 'caseTypeName',
          text: this.local.caseFile.tableHeader.caseType,
        },
        {
          value: 'caseDate',
          text: this.local.caseFile.tableHeader.caseDate,
          formatter: getDayMonthHijri,
        },
      ],
      loading: false,
      showUpdateAttorneyDetailsModal: false,
      formModel: {},
      isDisabledBasedOnPermission: true,
    };
  },
  computed: {
    caseObjectKey() {
      return this.$route.params.caseObjectKey;
    },
    isPega() {
      return this.$route.params.isPega;
    },
    caseFileTabs() {
      const tabs = [
        {
          href: '#tab-1',
          icon: 'mdi-file-table',
          title: this.local.caseFile.tabHeaders.caseDetails,
          isEnabled: true,
          isDisabled: false,
        },
        {
          href: '#tab-2',
          icon: 'mdi-reply-outline',
          title: this.local.caseFile.tabHeaders.lawsuitReplyForm,
          isEnabled: this.isPega.toString() == 'true',
          isDisabled: this.isDisabledBasedOnPermission,
        },
        {
          href: '#tab-3',
          icon: 'mdi-sitemap',
          title: this.local.caseFile.tabHeaders.caseParties,
          isEnabled: true,
          isDisabled: this.isDisabledBasedOnPermission,
        },
        {
          href: '#tab-4',
          icon: 'mdi-account-group',
          title: this.local.caseFile.tabHeaders.sessions,
          isEnabled: true,
          isDisabled: this.isDisabledBasedOnPermission,
        },
        {
          href: '#tab-5',
          icon: 'mdi-gavel',
          title: this.local.caseFile.tabHeaders.judgements,
          isEnabled: true,
          isDisabled: this.isDisabledBasedOnPermission,
        },
        {
          href: '#tab-6',
          icon: 'mdi-archive',
          title: this.local.caseFile.tabHeaders.requests,
          isEnabled: true,
          isDisabled: this.isDisabledBasedOnPermission,
        },
        {
          href: '#tab-10',
          icon: 'mdi-archive',
          title: this.local.caseFile.tabHeaders.procedures,
          isEnabled: true,
          isDisabled: this.isDisabledBasedOnPermission,
        },
        {
          href: '#tab-7',
          icon: 'mdi-bookshelf',
          title: this.local.caseFile.tabHeaders.decisions,
          isEnabled: true,
          isDisabled: this.isDisabledBasedOnPermission,
        },
        {
          href: '#tab-8',
          icon: 'mdi-cash-multiple',
          title: this.local.caseFile.tabHeaders.fees,
          isEnabled: this.isPega == 'true',
          isDisabled: this.isDisabledBasedOnPermission,
        },
        {
          href: '#tab-9',
          icon: 'mdi-file-document',
          title: this.local.caseFile.tabHeaders.documents,
          isEnabled: true,
          isDisabled: this.isDisabledBasedOnPermission,
        },
        {
          href: '#tab-11',
          icon: 'mdi-account-group',
          title: this.local.caseFile.tabHeaders.suspensions,
          isEnabled: this.caseDetails.isBankruptcy,
          isDisabled: this.isDisabledBasedOnPermission,
        },
      ];
      return tabs.filter(t => t.isEnabled);
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    getDayMonthHijri,
    ...mapActions([
      'getCaseInfo',
      'checkUserHasValidPermission',
    ]),
    loadData() {
      this.loading = true;
      this.checkUserHasValidPermission(this.caseObjectKey)
        .then((result) => {
          const hasPermissionVal = result?.data?.hasPermission;
          if (hasPermissionVal) {
            this.getCaseDetails();
          } else if (!hasPermissionVal) {
            this.formModel = {
              attorneyTypeId: result?.data?.attorneyTypeId,
              attorneyNumber: result?.data?.attorneyNumber,
              casePartyId: result?.data?.casePartyId,
              caseObjectKey: this.caseObjectKey,
              casePartyIdentityNumber: result?.data?.casePartyIdentityNumber,
              casePartyRole: result?.data?.casePartyRole,
              isTraineeLawyer: result?.data?.isTraineeLawyer,
            };
            this.showUpdateAttorneyDetailsModal = true;
          }
        }).catch(() => {
          this.$router.push({ path: '/' });
        }).finally(() => (this.loading = false));
    },
    getCaseDetails() {
      this.showUpdateAttorneyDetailsModal = false;
      this.isDisabledBasedOnPermission = false;

      const params = {
        objectKey: this.caseObjectKey,
        isPega: this.isPega,
      };

      this.loading = true;
      this.getCaseInfo(params)
        .then((res) => {
          this.caseDetails = res.data;
        })
        .catch((err) => {
          this.toaster.error(err.message);
          // todo: navigate to home
        })
        .finally(() => (this.loading = false));
    },
    casePartyAttorneyUpdate() {
      this.getCaseDetails();
    },
  },
};
</script>

<style lang="scss" scoped >
.tab-button {
  margin: 5px;
  margin-left: 0px;
  font: normal normal normal 16px/24px Almarai;
  justify-content: right;
  letter-spacing: 0px;
  color: #8e9090 !important;
  opacity: 1;

  .tab-button-icon {
    color: #8e9090 !important;
  }

  &:hover {
    color: var(--app-primary-color) !important;
    font-weight: bold;
    background: var(--app-light-secondary-color) 0% 0% no-repeat padding-box !important;

    .tab-button-icon {
      color: var(--app-primary-color) !important;
    }
  }
}

.tab-active {
  font-weight: bold;
  color: var(--app-lighter-primary-color) !important;
  border-left: 4px solid var(--app-lighter-primary-color);

  .tab-button-icon {
    color: var(--app-primary-color) !important;
  }
}

::v-deep .tab-details {
  box-shadow: 5px 5px 5px #00000014;
  border-radius: 22px;
  min-height: 534px;
}

.info-item-box {
  display: flex;
  justify-content: space-between;
  flex: 1;
  height: 100%;
}

.info-item-details {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1;
  color: var(--app-dark-primary-color);
  min-height: 140px;
}

.info-item-details-title {
  font-size: 14px;
}

.info-item-details-header {
  font-size: 16px;
}

.info-item-details-value {
  font-weight: bold;
  font-size: 16px;
}

::v-deep .text-c-green {
  color: var(--app-primary-color);
}

.header-card {
  background-color: rgba(228, 221, 221, 0.22);
}

.info-item-box-b {
  background: var(--app-light-secondary-color) 0% 0% no-repeat padding-box;
}

.font-info {
  font-size: 16px;
  font-weight: 900;
}
</style>
